import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useAuth } from '../aws/AuthContext';

const API_BASE_URL = process.env.REACT_APP_API_URL;
const API_URL = `${API_BASE_URL}/v1-ventas-espera`;

export const useVentasEspera = () => {
    const queryClient = useQueryClient();
    const { getJwtToken } = useAuth();

    const getEspera = useQuery({
        queryKey: ['ventas-espera'],
        queryFn: async () => {
            const token = await getJwtToken();
            const { data } = await axios.get(API_URL, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return data;
        },
        // --- CAMBIOS AQUÍ ---
        staleTime: Infinity,           // La data nunca se considera "vieja" por sí sola
        cacheTime: 1000 * 60 * 60,     // Mantiene en memoria 1 hora
        refetchOnWindowFocus: false,   // No consulta al cambiar de pestaña
        refetchOnReconnect: false,     // No consulta al volver el internet
        // refetchInterval: 15000,     // ELIMINADO: Ya no consulta cada 15 segundos
    });

    const saveEspera = useMutation({
        mutationFn: async (payload) => {
            const token = await getJwtToken();
            if (payload.id) {
                return axios.put(`${API_URL}/${payload.id}`, payload, {
                    headers: { Authorization: `Bearer ${token}` }
                });
            }
            return axios.post(API_URL, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });
        },
        // Al tener éxito, esto fuerza una única consulta para traer lo nuevo
        onSuccess: () => queryClient.invalidateQueries(['ventas-espera'])
    });

    const deleteEspera = useMutation({
        mutationFn: async (id) => {
            const token = await getJwtToken();
            return axios.delete(`${API_URL}/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
        },
        // Al borrar, actualizamos la lista local
        onSuccess: () => queryClient.invalidateQueries(['ventas-espera'])
    });

    return { getEspera, saveEspera, deleteEspera };
};